const _KST_MSEC = 1000 * 60 * 60 * 9;

function getDateFormat(period, isTooltip = false) {
    if (isTooltip) {
        if (period === 'minutes') return '%H:%M';
        return '%y.%m.%d'
    }

    if (period === 'minutes') return '%H';
    return '%m';
}

let globalOptions = (Highcharts, options, colors) => {
    return {
        credits: {
            enabled: false
        },
        chart: {
            animation: false,
            events: {
                render: function () {
                    // 밴드
                    let labelWidth = this.chartWidth - this.plotBackground.element.width.baseVal.value - 10;

                    this.get('main-yaxis').plotLinesAndBands.forEach(plab => {
                        if (!plab.label) return;

                        plab.label.element.style.width = `${labelWidth}px`;
                    });

                    if (options && options.chart && options.chart.events && typeof options.chart.events.render === "function") {
                        options.chart.events.render(this)
                    }
                },
                click: options && options.chart && options.chart.events && options.chart.events.click,
            },
            resetZoomButton: {
                theme: {
                    display: 'none'
                }
            }
        },
        rangeSelector: {
            enabled: false
        },
        scrollbar: {
            liveRedraw: true
        },
        navigator: {
            enabled: false,
            margin: 35
        },
        xAxis: {
            id: 'main-xaxis',
            labels: {
                enabled: false
            },
            crosshair: {
                snap: false
            },
            tickWidth: 0
        },
        tooltip: {
            shared: false,
            formatter: function () {
                const point = this.point || this.points[0].point;
                let chart = point.series.chart;
                let date = Highcharts.dateFormat(getDateFormat('days', true), chart.dateLabels[this.x] + _KST_MSEC);

                let txt = '';

                if (point.open) {
                    txt += `일자: ${date}<br>`;
                    if (chart.period === 'minutes') {
                        txt += `시간: ${Highcharts.dateFormat(getDateFormat('minutes', true), chart.dateLabels[this.x] + _KST_MSEC)}<br>`;
                    }

                    let prevData = this.x === 0 ? point.open : point.series.yData[this.x - 1];
                    let openRatio = (point.open - prevData[3]) / prevData[3];
                    let highRatio = (point.high - prevData[3]) / prevData[3];
                    let lowRatio = (point.low - prevData[3]) / prevData[3];
                    let closeRatio = (point.close - prevData[3]) / prevData[3];

                    txt += `시가: ${Highcharts.numberFormat(point.open, 0)} <span style="color:${openRatio > 0 ? '#f23743' : openRatio === 0 ? '#333' : '#297ee4'}">(${Highcharts.numberFormat(openRatio * 100)}%)</span><br>`;
                    txt += `고가: ${Highcharts.numberFormat(point.high, 0)} <span style="color:${highRatio > 0 ? '#f23743' : highRatio === 0 ? '#333' : '#297ee4'}">(${Highcharts.numberFormat(highRatio * 100)}%)</span><br>`;
                    txt += `저가: ${Highcharts.numberFormat(point.low, 0)} <span style="color:${lowRatio > 0 ? '#f23743' : lowRatio === 0 ? '#333' : '#297ee4'}">(${Highcharts.numberFormat(lowRatio * 100)}%)</span><br>`;
                    txt += `종가: ${Highcharts.numberFormat(point.close, 0)} <span style="color:${closeRatio > 0 ? '#f23743' : closeRatio === 0 ? '#333' : '#297ee4'}">(${Highcharts.numberFormat(closeRatio * 100)}%)</span><br>`;

                    let volume = chart.get('volume');
                    if (volume.visible) {
                        txt += `거래량: ${Highcharts.numberFormat(volume.yData[this.x], 0)}`;
                    }
                }

                if (options !== undefined && options.tooltip !== undefined && typeof options.tooltip.formatterHook === 'function') {
                    txt = options.tooltip.formatterHook(chart, point, txt);
                }

                return txt;
            }
        },
        plotOptions: {
            sma: {
                marker: {
                    enabled: false
                }
            },
            candlestick: {
                color: colors.fallColor,
                lineColor: colors.fallColor,
                upColor: colors.riseColor,
                upLineColor: colors.riseColor,
                dataGrouping: {
                    enabled: false
                }
            },
            series: {
                animation: false,
                turboThreshold: 0,
                stickyTracking: false,
                states: {
                    inactive: {
                        opacity: 1
                    }
                },
                crisp: false,
            },
            column: {
                dataGrouping: {
                    enabled : false
                },
                pointPadding: 0,
                groupPadding: 0.1,
                color: colors.riseColor,
                negativeColor: colors.fallColor,
                minPointLength: options && options.plotOptions && options.plotOptions.column && options.plotOptions.column.minPointLength || 0
            }
        },
        navigation: options && options.navigation,
        stockTools: options && options.stockTools
    }
}

export default globalOptions;